import multiSelect from '../../common/MultiSelect'
import config from '../../config'
import swal from 'sweetalert2'
import router from '../../router/router'
import { API } from '../../services'
import { resetStateToDefault, isMobile } from '../../utils'

function defaultState () {
  return {
    onlyMineGroup: null,
    name: '',
    ...multiSelect.mapStates(['companies']),
    reason: '',
    pwd: '',
    kind: 'group', // group | mine
    personal: false
  }
}

const mutations = {
  ...multiSelect.mapMutations(['companies']),
  resetState (state) {
    const result = defaultState()
    delete result['companies']
    delete result['onlyMineGroup']
    resetStateToDefault(state, result)
  },
  onlyMineGroup (state, payload) {
    state.onlyMineGroup = Boolean(payload)
    if (state.onlyMineGroup) {
      state.kind = 'mine'
    }
  },
  email (state, email) {
    state.email = email
  },
  name (state, name) {
    state.name = name
  },
  reason (state, reason) {
    state.reason = reason
  },
  pwd (state, pwd) {
    state.pwd = pwd
  },
  kind (state, value) {
    if (!['mine', 'group'].includes(value)) {
      throw new Error('Wrong argument for kind mutation in chooseCompany screen')
    }

    state.kind = value
  }
}

const actions = {
  async createBrowserRecord ({ state, rootState, commit }) {

    if (state.name.length < 3 || state.reason.length < 3) {
      swal({ type: 'info', text: 'Preencha adequadamente os campos Nome e Motivo' })
    }

    let params = {
      compMan: rootState.accessData.compMan.id,
      reason: state.reason,
      name: state.name,
      email: state.email,
    }

    if (state.kind === 'mine' || state.onlyMineGroup) {
      params.pwd = state.pwd
    } else {
      params.companies = state.companies.selected.map(i => ({id: i.id}))
    }

    try {
      params.userAgent = navigator.userAgent
      params.isMobile = isMobile()
      params.appVersion = config.version
    } catch (e) {
      params.appVersion = "2.0.0"
      console.warn('Cant get user agent')
    }


    try {
      const result = await API.device.save(params)
      commit('setBrowserRecord', result.data.success, {root: true})
      router.push({name: 'password'})
    } catch (e) {
      console.error(e)
      swal({type: 'error', text: e.body.error})
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations,
  actions
}
